import { CreateDeleteActionFunction } from 'mk2/containers/Deletion/Deletion.actions';
import { memoizeOne } from 'mk2/helpers/cache';
import { AppState } from 'mk2/reducers';
import { DeletionsState, initialDeletionsState } from './Deletion.reducers';
import { deletionKey, DeletionTargetType } from './Deletion.schemas';

export const getDeletionsState = (state: AppState): DeletionsState =>
    state.containers.global.deletion || initialDeletionsState;

export const getDeletionShownForTarget = memoizeOne(
    (deletionsState: DeletionsState, targetType: DeletionTargetType, targetId: number): boolean => {
        const key = deletionKey(targetType, targetId);
        return deletionsState[key] ? deletionsState[key].show : false;
    },
);

export const getDeletionCreateDeleteAction = (state: AppState, targetType: DeletionTargetType, targetId: number): CreateDeleteActionFunction => {
    const deletionsState = getDeletionsState(state);
    const key = deletionKey(targetType, targetId);
    return deletionsState[key] ? deletionsState[key].createDeleteAction : null;
};
